

import React from "react";
import "../../../assets/css/user/howDealsWork/HowDealsWork.css";


const deals = [
  {
    id: 1,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
        />
      </svg>
    ),
    iconBg: "linear-gradient(135deg, #FF6B35 0%, #E53E3E 100%)",
    label: "Instant Deals",
    labelColor: "#E53E3E",
    description:
      "Limited-time offers that expire fast. Grab them before they're gone! Sellers post unused slots at deep discounts.",
  },
  {
    id: 2,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C8 2 5 6 5 10c0 3 1.5 5.5 4 7l1 4h4l1-4c2.5-1.5 4-4 4-7 0-4-3-8-7-8z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle cx="12" cy="10" r="2" fill="white" />
      </svg>
    ),
    iconBg: "linear-gradient(135deg, #FF8C69 0%, #E53E3E 100%)",
    label: "Hot Deals",
    labelColor: "#E53E3E",
    description:
      "Most popular and best-selling deals in the marketplace. High demand, proven quality.",
  },
  {
    id: 3,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polyline
          points="22 7 13.5 15.5 8.5 10.5 2 17"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          points="16 7 22 7 22 13"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    iconBg: "linear-gradient(135deg, #F6C90E 0%, #F09000 100%)",
    label: "Trending Deals",
    labelColor: "#D97706",
    description:
      "Top-rated deals by our community. Highly reviewed and recommended by customers.",
  },
];

export default function HowDealsWork() {
  return (
    <section className="hdw-section">
      <div className="hdw-header">
        <h2 className="hdw-title">How Our Deals Work</h2>
        <p className="hdw-subtitle">Three types of deals to match every buyer's need</p>
      </div>

      <div className="hdw-cards">
        {deals.map((deal) => (
          <div className="hdw-card" key={deal.id}>
            <div className="hdw-icon-wrap" style={{ background: deal.iconBg }}>
              {deal.icon}
            </div>
            <h3 className="hdw-label" style={{ color: deal.labelColor }}>
              {deal.label}
            </h3>
            <p className="hdw-desc">{deal.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}